/* RESPONSIBLE TEAM: team-automation-foundations */
import type CreateSalesforceCase from 'embercom/models/operator/visual-builder/step/create-salesforce-case';
import StepConfig, { type StepConfigParams } from '../step';

export default class CreateSalesforceCaseConfiguration extends StepConfig {
  declare step: CreateSalesforceCase;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/create-salesforce-case',
      ...params,
    });
  }
}
